/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GHUBFREQUENCY } from './GHUBFREQUENCY';
import {
    GHUBFREQUENCYFromJSON,
    GHUBFREQUENCYFromJSONTyped,
    GHUBFREQUENCYToJSON,
} from './GHUBFREQUENCY';

/**
 * 
 * @export
 * @interface AnnuityDetails
 */
export interface AnnuityDetails {
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    clientId: number;
    /**
     * 
     * @type {string}
     * @memberof AnnuityDetails
     */
    productNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnuityDetails
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnuityDetails
     */
    incomeType?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    incomePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    grossAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnuityDetails
     */
    taxType?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    taxDue?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    iT88?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    maintenaceOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    netAmountPaid?: number;
    /**
     * 
     * @type {Date}
     * @memberof AnnuityDetails
     */
    nextPaymentDate?: Date;
    /**
     * 
     * @type {GHUBFREQUENCY}
     * @memberof AnnuityDetails
     */
    frequency?: GHUBFREQUENCY;
    /**
     * 
     * @type {Date}
     * @memberof AnnuityDetails
     */
    nextAnniversaryDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof AnnuityDetails
     */
    growthPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnuityDetails
     */
    bankAccountPaidTo?: string;
}

/**
 * Check if a given object implements the AnnuityDetails interface.
 */
export function instanceOfAnnuityDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;

    return isInstance;
}

export function AnnuityDetailsFromJSON(json: any): AnnuityDetails {
    return AnnuityDetailsFromJSONTyped(json, false);
}

export function AnnuityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnuityDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['ClientId'],
        'productNumber': !exists(json, 'ProductNumber') ? undefined : json['ProductNumber'],
        'productName': !exists(json, 'ProductName') ? undefined : json['ProductName'],
        'incomeType': !exists(json, 'IncomeType') ? undefined : json['IncomeType'],
        'incomePercentage': !exists(json, 'IncomePercentage') ? undefined : json['IncomePercentage'],
        'grossAmount': !exists(json, 'GrossAmount') ? undefined : json['GrossAmount'],
        'taxType': !exists(json, 'TaxType') ? undefined : json['TaxType'],
        'taxDue': !exists(json, 'TaxDue') ? undefined : json['TaxDue'],
        'iT88': !exists(json, 'IT88') ? undefined : json['IT88'],
        'maintenaceOrder': !exists(json, 'MaintenaceOrder') ? undefined : json['MaintenaceOrder'],
        'netAmountPaid': !exists(json, 'NetAmountPaid') ? undefined : json['NetAmountPaid'],
        'nextPaymentDate': !exists(json, 'NextPaymentDate') ? undefined : (new Date(json['NextPaymentDate'])),
        'frequency': !exists(json, 'Frequency') ? undefined : GHUBFREQUENCYFromJSON(json['Frequency']),
        'nextAnniversaryDate': !exists(json, 'NextAnniversaryDate') ? undefined : (new Date(json['NextAnniversaryDate'])),
        'growthPercentage': !exists(json, 'GrowthPercentage') ? undefined : json['GrowthPercentage'],
        'bankAccountPaidTo': !exists(json, 'BankAccountPaidTo') ? undefined : json['BankAccountPaidTo'],
    };
}

export function AnnuityDetailsToJSON(value?: AnnuityDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientId': value.clientId,
        'ProductNumber': value.productNumber,
        'ProductName': value.productName,
        'IncomeType': value.incomeType,
        'IncomePercentage': value.incomePercentage,
        'GrossAmount': value.grossAmount,
        'TaxType': value.taxType,
        'TaxDue': value.taxDue,
        'IT88': value.iT88,
        'MaintenaceOrder': value.maintenaceOrder,
        'NetAmountPaid': value.netAmountPaid,
        'NextPaymentDate': value.nextPaymentDate === undefined ? undefined : (value.nextPaymentDate.toISOString()),
        'Frequency': GHUBFREQUENCYToJSON(value.frequency),
        'NextAnniversaryDate': value.nextAnniversaryDate === undefined ? undefined : (value.nextAnniversaryDate.toISOString()),
        'GrowthPercentage': value.growthPercentage,
        'BankAccountPaidTo': value.bankAccountPaidTo,
    };
}

